import { DevTools } from 'jotai-devtools';
import { useConfig } from '@/contexts/ConfigContext';

export const JotaiDevToolsProvider = () => {
  const config = useConfig();
  return config.ENABLE_JOTAI_DEVTOOLS ? <DevTools /> : null;
};
